(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.remove('oddit-js');
    for (const el of document.querySelectorAll('.oddit-reveal')) {
      el.classList.add('is-visible');
    }
    return;
  }

  /* ---------- Scroll-triggered reveals ---------- */

  const REVEAL_SELECTOR = '.oddit-reveal';
  const EARLY_CLASS = 'oddit-reveal--early';
  const STAGGER_ATTR = 'data-oddit-stagger';
  const VISIBLE_CLASS = 'is-visible';

  function assignStaggerIndices(parent) {
    const children = parent.querySelectorAll(':scope > ' + REVEAL_SELECTOR);
    let idx = 0;
    for (const child of children) {
      child.style.setProperty('--oddit-stagger-index', idx);
      idx++;
    }
  }

  function handleIntersection(entries, observer) {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const el = entry.target;
      el.classList.add(VISIBLE_CLASS);
      observer.unobserve(el);
    }
  }

  /* Tighter bottom inset on narrow viewports so reveals fire earlier while scrolling (PT-207). */
  var DESKTOP_BREAKPOINT = 990;
  function isCompactViewport() {
    return window.innerWidth < DESKTOP_BREAKPOINT;
  }

  var revealRootMargin = isCompactViewport() ? '0px 0px -5% 0px' : '0px 0px -10% 0px';
  var sectionRootMargin = isCompactViewport() ? '0px 0px -8% 0px' : '0px 0px -10% 0px';

  const revealObserver = new IntersectionObserver(handleIntersection, {
    rootMargin: revealRootMargin,
    threshold: 0.01,
  });

  const earlyRevealObserver = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 0% 0px',
    threshold: 0.01,
  });

  function initReveals(root) {
    for (const staggerParent of root.querySelectorAll('[' + STAGGER_ATTR + ']')) {
      assignStaggerIndices(staggerParent);
    }

    for (const el of root.querySelectorAll(REVEAL_SELECTOR)) {
      if (el.classList.contains(VISIBLE_CLASS)) continue;
      var obs = el.classList.contains(EARLY_CLASS) ? earlyRevealObserver : revealObserver;
      obs.observe(el);
    }
  }

  /* ---------- Parallax ---------- */

  const PARALLAX_SELECTOR = '.oddit-parallax';
  const parallaxItems = [];
  var cachedViewH = window.innerHeight;

  function initParallax(root) {
    for (const el of root.querySelectorAll(PARALLAX_SELECTOR)) {
      parallaxItems.push({
        el: el,
        speed: parseFloat(el.dataset.odditParallaxSpeed) || 0.15,
      });
    }
  }

  function updateParallax() {
    const scrollY = window.scrollY;

    for (var i = 0; i < parallaxItems.length; i++) {
      const item = parallaxItems[i];
      const rect = item.el.getBoundingClientRect();
      const elTop = rect.top + scrollY;
      const elH = rect.height;

      if (elTop + elH < scrollY || elTop > scrollY + cachedViewH) continue;

      const offset = (scrollY + cachedViewH / 2 - elTop - elH / 2) * item.speed;
      item.el.style.transform = 'translateY(' + offset + 'px)';
    }
  }

  let parallaxTicking = false;
  function onScroll() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    requestAnimationFrame(function () {
      updateParallax();
      parallaxTicking = false;
    });
  }

  /* ---------- Init ---------- */

  var sectionObserver = new IntersectionObserver(
    function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('oddit-section-active');
        obs.unobserve(entries[i].target);
      }
    },
    { rootMargin: sectionRootMargin, threshold: 0.01 },
  );

  var revealsStarted = false;
  function startReveals() {
    if (revealsStarted) return;
    revealsStarted = true;

    var staggerParents = document.querySelectorAll('[' + STAGGER_ATTR + ']');
    for (var i = 0; i < staggerParents.length; i++) {
      assignStaggerIndices(staggerParents[i]);
    }

    var allReveals = document.querySelectorAll(REVEAL_SELECTOR);
    var viewH = window.innerHeight;
    var groups = [];
    var wrapperMap = {};
    var classified = {};

    for (var i = 0; i < allReveals.length; i++) {
      var el = allReveals[i];
      if (el.classList.contains(VISIBLE_CLASS)) continue;

      var isEarly = el.classList.contains(EARLY_CLASS);
      var observer = isEarly ? earlyRevealObserver : revealObserver;

      var wrapper = el.closest('.shopify-section');
      if (!wrapper) {
        observer.observe(el);
        continue;
      }

      var wid = wrapper.id || (wrapper.id = '_s' + i);

      if (classified[wid] === 'offscreen') {
        observer.observe(el);
        continue;
      }
      if (wrapperMap[wid]) {
        wrapperMap[wid].els.push(el);
        continue;
      }

      var rect = wrapper.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top >= viewH) {
        classified[wid] = 'offscreen';
        sectionObserver.observe(wrapper);
        observer.observe(el);
        continue;
      }

      wrapperMap[wid] = { wrapper: wrapper, els: [el] };
      groups.push(wrapperMap[wid]);
    }

    var STAGGER_STEP = 60;
    var TRANSITION_OVERLAP = 150;
    var cumDelay = 0;

    var revealThreshold = viewH + 30;

    for (var g = 0; g < groups.length; g++) {
      (function (group, delay) {
        setTimeout(function () {
          group.wrapper.classList.add('oddit-section-active');
          for (var j = 0; j < group.els.length; j++) {
            var elRect = group.els[j].getBoundingClientRect();
            if (elRect.top < revealThreshold && elRect.bottom > 0) {
              group.els[j].classList.add(VISIBLE_CLASS);
            } else {
              var obs = group.els[j].classList.contains(EARLY_CLASS) ? earlyRevealObserver : revealObserver;
              obs.observe(group.els[j]);
            }
          }
        }, delay);
      })(groups[g], cumDelay);

      var maxIdx = 0;
      for (var k = 0; k < groups[g].els.length; k++) {
        var idx = parseInt(groups[g].els[k].style.getPropertyValue('--oddit-stagger-index')) || 0;
        if (idx > maxIdx) maxIdx = idx;
      }
      cumDelay += maxIdx * STAGGER_STEP + TRANSITION_OVERLAP;
    }

    var allSections = document.querySelectorAll('.shopify-section');
    for (var s = 0; s < allSections.length; s++) {
      if (!allSections[s].classList.contains('oddit-section-active') && !classified[allSections[s].id]) {
        allSections[s].classList.add('oddit-section-active');
      }
    }
  }

  function init() {
    initParallax(document);

    if (parallaxItems.length > 0) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener(
        'resize',
        function () {
          cachedViewH = window.innerHeight;
        },
        { passive: true },
      );
      updateParallax();
    }

    var overlays = document.querySelectorAll('.oddit-cart-drawer');
    for (var o = 0; o < overlays.length; o++) {
      var ow = overlays[o].closest('.shopify-section');
      if (ow) ow.style.opacity = '1';
    }

    var entranceEls = document.querySelectorAll('.oddit-entrance');
    var scrolledPastEntrance = window.scrollY > window.innerHeight * 0.5;

    if (entranceEls.length > 0 && !scrolledPastEntrance) {
      for (var i = 0; i < entranceEls.length; i++) {
        var w = entranceEls[i].closest('.shopify-section');
        if (w) w.style.opacity = '1';
      }

      var last = entranceEls[entranceEls.length - 1];
      last.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'opacity') return;
        last.removeEventListener('transitionend', onEnd);
        for (var j = 0; j < entranceEls.length; j++) {
          entranceEls[j].classList.add('is-entered');
        }
        startReveals();
      });
      setTimeout(function () {
        for (var j = 0; j < entranceEls.length; j++) {
          entranceEls[j].classList.add('is-entered');
        }
        startReveals();
      }, 1250);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          for (var i = 0; i < entranceEls.length; i++) {
            entranceEls[i].classList.add('is-entering');
          }
        });
      });
    } else {
      for (var i = 0; i < entranceEls.length; i++) {
        entranceEls[i].classList.add('is-entering');
        entranceEls[i].classList.add('is-entered');
        var w = entranceEls[i].closest('.shopify-section');
        if (w) w.style.opacity = '1';
      }
      startReveals();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---------- Shopify editor support ---------- */

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    function editorRevealSection(sectionEl) {
      var wrapper = sectionEl.closest('.shopify-section') || sectionEl;
      wrapper.classList.add('oddit-section-active');
      wrapper.style.opacity = '1';

      for (var i = 0; i < sectionEl.querySelectorAll('[' + STAGGER_ATTR + ']').length; i++) {
        assignStaggerIndices(sectionEl.querySelectorAll('[' + STAGGER_ATTR + ']')[i]);
      }

      var reveals = sectionEl.querySelectorAll(REVEAL_SELECTOR);
      for (var j = 0; j < reveals.length; j++) {
        reveals[j].classList.add(VISIBLE_CLASS);
      }

      var entrances = sectionEl.querySelectorAll('.oddit-entrance');
      for (var k = 0; k < entrances.length; k++) {
        entrances[k].classList.add('is-entering');
        entrances[k].classList.add('is-entered');
      }

      initParallax(sectionEl);
    }

    document.addEventListener('shopify:section:load', function (event) {
      editorRevealSection(event.target);
    });

    document.addEventListener('shopify:section:select', function (event) {
      editorRevealSection(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      editorRevealSection(event.target.closest('.shopify-section') || event.target);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      editorRevealSection(event.target.closest('.shopify-section') || event.target);
    });
  }
})();
